import { useParentAppLayout } from '@src/components/sco/AppLayout/AppLayoutContext';
import { useEducationContext } from '@src/components/sco/Education/EducationContext';
import { VideoLanding } from '@src/components/sco/Education/VideoLanding';
import { VideoSearch } from '@src/components/sco/Education/VideoSearch';
import { EducationPage } from '@src/templates/EducationPage';
import React, { useEffect } from 'react';
export { getServerSideProps } from '@src/lib/server-side-rendering';
export default EducationPage(function Page(props) {
  const layout = useParentAppLayout();
  const educationContext = useEducationContext();
  useEffect(() => {
    layout.updatePanel('edu-aside', {
      isPanelOpen: false
      // isDrawerOpen: false,
    });
    educationContext.setActiveSection('videos.landing');
  }, [false]);
  const showSearch = educationContext.activeTerms?.length > 0 || educationContext.activeKeywords;
  return showSearch ? <VideoSearch /> : <VideoLanding />;
});